import React, {useContext, useEffect, useState} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {BaseUrl} from "../../../../contexts/baseUrl/baseUrl";
import Layout from "../../../../components/sales/layout/layout";
import Images from "assets/images/imageData";

const DealerWalletListing = ({
    walletListingDealer,
    listing = []
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [approvedAmount, setApprovedAmount] = useState(0);
    const [setteledAmount, setSetteledAmount] = useState(0);
    const [creditAmount, setCreditAmount] = useState(0);
    console.log('PAGE::DEALER_WALLET_LISTING');
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await walletListingDealer(1)
            setIsLoading(false)
        })()
    }, [])

    const headers = [
        'Dealer Id',
        'Dealer User Id',
        'Business Id',
        'Requested Amount',
        'Attachment',
        'Remark',
        'Status',
        'Head Approver',
        'Finance Approver',
        'Requested On'
        //'Approve/Reject'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await walletListingDealer(val.selected + 1);
        setIsLoading(false);
    };

     {console.log(listing)}
    useEffect(() => {
        const tableData = [
            'id',
            'dealer_id',
            'dealer_user_id',
            'business_id',
            'requested_amount',
            'doc',
            'remark',
            'status',
            'approved_by_head',
            'approved_by_finance',
            'created_on',
            //'Approve/Reject', 
        ];
        // console.log('fff ' + JSON.stringify(listing?.data[0]['doc']));
        if (listing && listing?.data !==undefined && listing?.data && listing?.data.length > 0) {
            const data = listing.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ((key === 'status' && element['status'] === 1) ? 
                    {[key]: 'Approved'} : (key === 'status' && element['status'] === 2) ? 
                    {[key]: 'Rejected'} : (key === 'status' && element['status'] === 3) ? 
                    {[key]: 'Approved By Head'} : (key === 'status' && element['status'] === 0) ? 
                    {[key]: 'Pending'} : 
                    key === 'doc' && (element['doc'].split('.').pop() === 'jpeg' || element['doc'].split('.').pop() === 'jpg' || element['doc'].split('.').pop() === 'png') ?
                    {
                        [key]: <a href={element['doc']} target="_blank"><img src={element['doc']}
                                                                                   style={{
                                                                                       "width": "48px",
                                                                                       "borderRadius": "16px",
                                                                                       "height": "48px"
                                                                                   }}/></a>
                    } :
                    key === 'doc' && element['doc'].split('.').pop() === 'doc' ? {
                            [key]: <a href={element['doc']} target="_blank"><img src={Images?.DocIcon}
                                                                                       alt=""
                                                                                       className="view-icon"/></a>
                        } :
                        key === 'doc' && element['doc'].split('.').pop() === 'pdf' ? {
                                [key]: <a href={element['doc']} target="_blank"><img src={Images?.DocIcon}
                                                                                           alt=""
                                                                                           className="view-icon"/></a>
                            } : 
                            {[key]: element[key]}
                     )
                    ),
                    
                )
                
            );  
            data && setListData(data);
            setPageCount(Math.ceil(listing.total / listing.per_page));
        }
        setCreditAmount(listing?.credit_amount);
        setApprovedAmount(listing?.approved_amount);
        setSetteledAmount(listing?.setteled_amount);
      }, [listing]);

    const headerButtons = () => {
        return (
            <>
            <span style={{'marginRight': '2rem', 'top': '1rem', 'position': 'relative'}}>
              Credit Amount : <b>{creditAmount}</b>
            </span>
            {/* <span style={{'marginRight': '2rem', 'top': '1rem', 'position': 'relative'}}>
              Approved Amount : <b>{approvedAmount}</b>
            </span>
            <span style={{'marginRight': '2rem', 'top': '1rem', 'position': 'relative'}}>
              Setteled Amount : <b>{setteledAmount}</b>
            </span> */}
            <a className="btn btn-primary" href={`${baseUrl}/dm-request`}>Add Request</a>
            </>
        )
    }

    return (
        <>
            <Layout
                title={localization.dealerWallet}
                isLoading={isLoading}
                //isGoback={true}
                Buttons={headerButtons}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={listing?.data && listing?.data?.resultSets}
                    srNo={listing?.from}
                />
            </Layout>
        </>
    )
}

export default DealerWalletListing;

